import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "../DropDown";
import apiClientTimeseries from "../../../services/apiClientTimeseries";
import { getHeaders as getMetricHeaders } from "../../ApiHeaders/apiHeadersTimeseries";

interface AttributeItem {
  name: string;
  web_id: string;
  path: string;
  type: string;
  end_value: string;
  timestamp: string;
}

interface AttributeDropdownProps {
  piElementPath: string | null;
  selectedAttribute: string;
  onAttributeChange: (value: string, obj?: AttributeItem) => void;
  disabled?: boolean;
  className?: string;
  onFocus?: () => void;
}

const AttributeDropdown: React.FC<AttributeDropdownProps> = ({
  piElementPath,
  selectedAttribute,
  onAttributeChange,
  disabled = false,
  className = "",
  onFocus,
}) => {
  const [attributes, setAttributes] = useState<AttributeItem[]>([]);



  useEffect(() => {
    if (!piElementPath) {
      setAttributes([]);
      return;
    }

    const fetchAttributes = async () => {
      try {
        const headers = await getMetricHeaders();
        const body = { path: piElementPath };

        const res = await apiClientTimeseries.post(
          "/pi/attributes",
          body,
          { headers }
        );

        const attrs: AttributeItem[] =
          res?.data?.attributes?.sort((a: AttributeItem, b: AttributeItem) =>
            a.name.localeCompare(b.name)
          ) || [];

        setAttributes(attrs);
      } catch (err) {
        console.error("Failed to fetch PI attributes:", err);
        setAttributes([]);
      }
    };

    fetchAttributes();
  }, [piElementPath]);


  const options = useMemo(
    () =>
      attributes.map((a) => ({
        value: a.name,
        label: a.name,
      })),
    [attributes]
  );



  return (
    <Dropdown
      options={options}
      selectedValue={selectedAttribute}
      onValueChange={(value) => {
        const obj = attributes.find((a) => a.name === value);
        onAttributeChange(value, obj);
      }}
      disabled={disabled}
      className={className}
      placeholder="Select Attribute"
      onFocus={onFocus}
    />
  );
};

export default AttributeDropdown;
